import React from 'react';
import { Box, Typography } from '@mui/material';
import useStyles from '../styles';
import CustomButton from '../../../components/General/CustomButton';

const DeletePhenStateNameModalContent = ({
  id,
  handleCloseModal,
  handleDeleteFunction,
  isLoadingDelete,
}: {
  id: string,
  handleCloseModal: VoidFunction,
  handleDeleteFunction: ({ id }: { id: string }) => void,
  isLoadingDelete: boolean,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.upsertVarietyModalContainer}>
      <Box className={classes.upsertVarietyModalHeader}>
        <Typography
          variant="h3"
          color="textPrimary"
          className={classes.upsertVarietyModalHeaderTitle}
        >
          <span className={classes.activePageUnderlined}>
            Eliminar estado fenológico
          </span>
        </Typography>
      </Box>
      <Box mt={2} mb={3}>
        <Typography>
          ¿Estás seguro de querer eliminar este estado fenológico del catálogo?
          Esta acción no se puede deshacer.
        </Typography>
      </Box>
      <Box className={classes.upsertVarietyModalButtonsContainer}>
        <Box width='100%' mr={2}>
          <CustomButton color='blue' buttonText='Cancelar' onClick={handleCloseModal} />
        </Box>
        <Box width='100%' ml={2}>
          <CustomButton
            color='red'
            buttonText='Eliminar'
            onClick={() => handleDeleteFunction({ id })}
            disabled={isLoadingDelete}
            setLoadingSpinnerWhenDisabled={true}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DeletePhenStateNameModalContent;
